// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a7158148","513":"518eb9bf"}[chunkId] + ".chunk.js";
};